(function () {
    function initAceiiScrollPhone() {
      var sections = document.querySelectorAll('.aceii-scroll-phone');

      sections.forEach(function (section) {
        if (!section || section.dataset.initialized === 'true') return;

        section.dataset.initialized = 'true';

        var sticky = section.querySelector('.asp-sticky');
        var screen = section.querySelector('.asp-phone-screen');
        var image = section.querySelector('.asp-long-image');
        var hint = section.querySelector('.asp-scroll-hint');

        if (!sticky || !screen || !image) return;

        var ticking = false;
        var imageTravel = 0;

        function clamp(value, min, max) {
          return Math.min(Math.max(value, min), max);
        }

        function calculateTravel() {
          var renderedImageHeight = image.getBoundingClientRect().height;

          imageTravel = Math.max(
            0,
            renderedImageHeight - screen.clientHeight
          );

          var prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          if (prefersReducedMotion) {
            section.style.height = '';
          } else {
            var scrollDistance = Math.max(
              window.innerHeight * 1.4,
              imageTravel * 1.25
            );

            section.style.height =
              sticky.clientHeight + scrollDistance + 'px';
          }

          update();
        }

        function update() {
          ticking = false;

          var sectionRect = section.getBoundingClientRect();
          var stickyHeight = sticky.clientHeight;
          var scrollRange = Math.max(
            1,
            section.offsetHeight - stickyHeight
          );

          var progress = clamp(
            -sectionRect.top / scrollRange,
            0,
            1
          );

          var translateY = imageTravel * progress;

          image.style.transform =
            'translate3d(0,' + (-translateY) + 'px,0)';

          if (hint) {
            hint.classList.toggle(
              'is-hidden',
              progress > 0.04
            );
          }

          section.style.setProperty(
            '--asp-progress',
            progress
          );
        }

        function requestUpdate() {
          if (ticking) return;

          ticking = true;
          window.requestAnimationFrame(update);
        }

        if (image.complete && image.naturalWidth) {
          calculateTravel();
        } else {
          image.addEventListener(
            'load',
            calculateTravel
          );
        }

        window.addEventListener(
          'scroll',
          requestUpdate,
          {
            passive: true
          }
        );

        window.addEventListener(
          'resize',
          function () {
            calculateTravel();
            requestUpdate();
          }
        );

        document.addEventListener(
          'visibilitychange',
          function () {
            if (!document.hidden) {
              calculateTravel();
              requestUpdate();
            }
          }
        );

        calculateTravel();
        requestUpdate();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initAceiiScrollPhone
      );
    } else {
      initAceiiScrollPhone();
    }

    document.addEventListener(
      'shopify:section:load',
      initAceiiScrollPhone
    );
  })();
